'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.migrateStyleFunction = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The currently installed version of glamorous (3.23.4) expects style functions
// to have the following params def:
// (props, theme) => ({ ...style... });
// We want to encourage usage of the updated params def:
// ({ theme, ...props }) => ({ ...style... });
// So we map and migrate the functions
var migrateStyleFunction = exports.migrateStyleFunction = function migrateStyleFunction(styleFunc) {
  if (styleFunc.length > 1) {
    console.warn('Getting theme from the second parameter of a dynamic style function is deprecated. Please extract theme from the first props parameter.');
  }

  return function (props, theme) {
    return styleFunc((0, _extends3.default)({}, props, { theme: theme }), theme);
  };
}; /**
    * Default styling function.
    * Wraps whatever library we're currently deciding to support.
    */


var styler = function styler(Component) {
  return function () {
    for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
      styles[_key] = arguments[_key];
    }

    return (0, _glamorous2.default)(Component).apply(undefined, (0, _toConsumableArray3.default)(styles.map(function (style) {
      if (typeof style === 'function') {
        // Migrate style function
        return migrateStyleFunction(style);
      }

      return style;
    })));
  };
};

exports.default = styler;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/styler.js
// module id = 633
// module chunks = 0